export default __webpack_public_path__ + "static/media/HSL_OpenMaaS_Lippujen_muutos-_ja_peruutusehdot_14.1.2021.8b20eb62.pdf";